﻿var loadServiceCentreDetailMapMarkers = function (markers) {
	if (markers) {

		jQuery(document).ready(function () {
			//The variables that will be used within the map configuration options.
			var serviceCentreMap; //The variable for the main map itself
			var serviceCentreMapCenter = new google.maps.LatLng(parseFloat(markers[0].Latitude), parseFloat(markers[0].Longitude)); //The latitude and longitude of the center of the map.
			var serviceCentreMapZoom = 18; //The degree to which the map is zoomed in. This can range from 0 (least zoomed) to 21 and above (most zoomed).
			var serviceCentreMapZoomMin = 4; //The min zoom levels that is allowed.
			var serviceCentreMapIcon = '/assets/img/map-marker.png';

			//These options configure the setup of the map.
			var serviceCentreMapOptions = {
				center: serviceCentreMapCenter,
				zoom: serviceCentreMapZoom,
				minZoom: serviceCentreMapZoomMin,
				icon: serviceCentreMapIcon,
				panControl: false,
				mapTypeControl: false,
				scrollwheel: false
			};

			loadServiceCentreDetailMap(markers);

			//Function that loads the map.
			function loadServiceCentreDetailMap(markers) {
				serviceCentreMap = new google.maps.Map(document.getElementById("map"), serviceCentreMapOptions);
				var infoWindow = new google.maps.InfoWindow({ content: '' });
                var infoWindowContent = '<div class=\"popup\"><div class=\"title\">{Name}</div><div class=\"address\">{Address}</div><div class="clearfix"><div class=\"email\"><a href=\"mailto:{Email}\">{Email}</a></div><div class=\"phone\"><a href=\"tel:{PhoneTrim}\">{Phone}</a></div><div class=\"location\"><a href=\"{Location}\" target="_blank">{Location}</a></div></div><div class=\"link-wrapper clearfix\"><a class=\"link\" href=\"{Url}\">View</a></div></div>';

				for (var i = 0; i < markers.length; i++) {
					var sc = markers[i];
					var lat = parseFloat(sc.Latitude);
					var long = parseFloat(sc.Longitude);

					if (lat != NaN && long != NaN) {
						var markerLatLng = { lat: sc.Latitude, lng: sc.Longitude };
						var marker = new google.maps.Marker({
							position: markerLatLng,
							map: serviceCentreMap,
							icon: serviceCentreMapIcon,
							title: sc.ServiceCentreName.replace('amp;', '')
						});

      //                  google.maps.event.addListener(marker, 'click', (function (serviceCentreMap, marker, infoWindow, infoWindowContent, sc) {
						//	return function () {
						//		infoWindow.close();
      //                          var phoneTrimmed = sc.Phone.replace(/(\d)\s+(?=\d)/g, '$1');
	  //                          var LocationLink = 'https://www.google.com/maps/search/'+sc.ServiceCentreName+'/@'+sc.Latitude+','+sc.Longitude+',17z';
      //                          infoWindow.setContent(infoWindowContent
      //                              .replace(/\{Name\}/g, sc.ServiceCentreName)
      //                              .replace(/\{Address\}/g, sc.FullAddress)
      //                              .replace(/\{Email\}/g, sc.Email)
      //                              .replace(/\{Phone\}/g, sc.Phone)
      //                              .replace(/\{Url\}/g, sc.ServiceCentreUrl)
      //                              .replace(/\{Location\}/g, LocationLink)
      //                              .replace(/\{PhoneTrim\}/g, phoneTrimmed));
						//		infoWindow.open(serviceCentreMap, marker);
						//	}
						//})(serviceCentreMap, marker, infoWindow, infoWindowContent, sc));
					}
				}
			}
		});
	}
}

module.exports = loadServiceCentreDetailMapMarkers;